import React, { useState } from 'react';
import { Edit2, Eye, EyeOff } from 'lucide-react';

const EditableTextField = ({ 
  label, 
  value = '', 
  onChange,
  placeholder = '',
  multiline = false,
  rows = 1,
  type = 'text' // Added type prop
}:any) => {
  // const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    // if (onChange) {
    //   onChange(value);
    // }
  };

  const handleChange = (e:any) => {
    onChange(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isPassword = type === 'password';
  const InputComponent = multiline ? 'textarea' : 'input';
  const inputType = isPassword && !showPassword ? 'password' : 'text';

  const containerStyle = {
    width: '100%',
    marginBottom: '16px'
  };

  const labelStyle:any = {
    display: 'block',
    marginBottom: '6px',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#666',
    textAlign: 'left'
  };

  const fieldContainerStyle:any = {
    position: 'relative',
    borderRadius: '8px',
    padding: '12px',
    paddingRight: isPassword ? '80px' : '48px',
    backgroundColor: isHovered ? '#e8e8e8' : '#f5f5f5',
    transition: 'background-color 0.2s ease',
    cursor: isEditing ? 'text' : 'default'
  };

  const inputStyle:any = {
    width: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    color: '#333',
    fontSize: '1rem',
    fontFamily: 'inherit',
    cursor: isEditing ? 'text' : 'default',
    resize: multiline ? 'none' : 'none'
  };

  const buttonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '8px',
    border: 'none',
    background: 'transparent',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease'
  };

  const editButtonStyle:any = {
    ...buttonStyle,
    right: isPassword ? '40px' : '8px'
  };

  const passwordToggleStyle:any = {
    ...buttonStyle,
    right: '8px'
  };

  return (
    <div style={containerStyle}>
      {label && (
        <label style={labelStyle}>
          {label}
        </label>
      )}
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={fieldContainerStyle}
      >
        <InputComponent
          type={multiline ? undefined : inputType}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          rows={multiline ? rows : undefined}
          disabled={!isEditing}
          style={inputStyle}
        />
        
        {/* Edit button */}
        {isHovered && !isEditing && (
          <button
            onClick={handleEditClick}
            style={editButtonStyle}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <Edit2 size={18} color="#666" />
          </button>
        )}

        {/* Password visibility toggle */}
        {isPassword && (
          <button
            onClick={togglePasswordVisibility}
            style={passwordToggleStyle}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.04)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            {showPassword ? (
              <EyeOff size={18} color="#666" />
            ) : (
              <Eye size={18} color="#666" />
            )}
          </button>
        )}
      </div>
    </div>
  );
};

export default EditableTextField;